/** @jsxImportSource @emotion/react */
import React from "react";

import LinearProgress from "@material-ui/core/LinearProgress";

import { grey, red } from "../../styles/variables";

export enum PROGRESS_STATUS {
  COMPLETED = "completed",
  PROCESSING = "processing",
  FAILED = "failed",
}

const useStyles = () => ({
  root: {
    height: "8px",
    borderRadius: 4,
    background: "transparent",
  },
  failed: {
    ".MuiLinearProgress-bar": {
      borderRadius: 4,
      background: red,
    },
  },
  defaultStyle: {
    ".MuiLinearProgress-bar": {
      borderRadius: 4,
    },
  },
  background: {
    height: "4px",
    borderRadius: 4,
    background: grey,
    marginTop: "-6px",
  },
});

interface ProgressBarProps {
  percentage?: number;
  status?: PROGRESS_STATUS;
}

const ProgressBar = ({ percentage = 100, status }: ProgressBarProps) => {
  const { root, failed, defaultStyle, background } = useStyles();
  let color;

  switch (status) {
    case PROGRESS_STATUS.FAILED:
      color = failed;
      break;
    case PROGRESS_STATUS.PROCESSING:
    case PROGRESS_STATUS.COMPLETED:
    default:
      color = defaultStyle;
      break;
  }
  return (
    <>
      <LinearProgress css={[root, color]} variant="determinate" value={percentage} />
      <div css={background} />
    </>
  );
};

export default ProgressBar;
